// extracted by mini-css-extract-plugin
export var badge = "DepositBonusBadge-module--badge--8af50";
export var badgeRow = "DepositBonusBadge-module--badgeRow--34795";
export var shinyText = "DepositBonusBadge-module--shinyText--427ce";